// Licensed to the Software Freedom Conservancy (SFC) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The SFC licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

import { WebDriverExecutor } from '.'
import createRecorderSyncronizer from './recording-syncronizer'
import { ScriptShape } from './webdriver'

export interface RecorderSynchronizerInput {
  executor: WebDriverExecutor
  sessionId: string
  logger: Console
}

export default function createRecorderSyncronizerForWebdriverExecutor({
  executor,
  sessionId,
  logger,
}: RecorderSynchronizerInput) {
  return createRecorderSyncronizer({
    sessionId,
    executeAsyncScript: (script: ScriptShape) =>
      executor.doExecuteAsyncScript(script),
    switchToWindow: (handle: string) =>
      executor.driver.switchTo().window(handle),
    getWindowHandle: () => executor.driver.getWindowHandle(),
    logger,
  })
}
